
import { loadRecipes } from "./recipes";

console.log("Init script loaded");

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector<HTMLElement>(".recipe-list");
  const apiUrl = el?.dataset.apiUrl;
  if (!apiUrl) return;

  loadRecipes(apiUrl);

  const form = document.querySelector("#recipe-form") as HTMLFormElement;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    await fetch(`${apiUrl}/api/recipes`, {
      method: "POST",
      body: formData
    });
    location.reload();
  });
});
